document.addEventListener('DOMContentLoaded', () => {
    // Burger Button
    const toggler = document.getElementById('navbar-toggler');
    if(toggler){
        toggler.addEventListener('click', () => {
            toggler.classList.toggle("is-active");
        });
    }
});


function toggleNavElements(id: string) {
    const parent = document.getElementById(id);
    const sibling = parent.nextElementSibling;
    const allLists = document.querySelectorAll('.list-show');

    if (!parent || !sibling) return;

    sibling.classList.toggle('list-show');

    if(allLists){
        allLists.forEach(list => list.classList.remove('list-show'));
    }
}

function toggleInnerNavElement(id: string) {
    const parent = document.getElementById('mobile-stack-name-' + id);
    const sibling = parent.nextElementSibling;
    sibling.classList.toggle('open-content')
}

document.addEventListener('DOMContentLoaded', () => {
    const groups = document.querySelectorAll('.group');
    if(groups){
        groups.forEach(group => {
            group.addEventListener('click', function (){
                const isClickedElements = document.querySelectorAll('.isClicked');
                this.classList.toggle('isClicked')
                isClickedElements.forEach(element => element.classList.remove('isClicked'))
            })
        })
    }
    // Close Button Nav-Items
    const btnItemClose = document.getElementById('btnItemClose');
    btnItemClose?.addEventListener('click',()=>{
        groups.forEach(group=>{
            group.classList.remove('isClicked')
        })
    });

    // Close Button Nav-Login
    const navLogin = document.getElementById('navLogin');
    const btnLoginClose = document.getElementById('btnLoginClose');

    btnLoginClose?.addEventListener('click',()=>{
        navLogin.classList.remove('isClicked');
    });
});

// Body um Höhe der Nav nach unten schieben
// function adjustBodyPaddingToNavigation(): void {
//     const nav = document.getElementById('big-navigation');
//     if (!nav) return;

//     const navHeight = nav.offsetHeight;
//     document.body.style.paddingTop = `${navHeight}px`;
// }

// Beim Laden ausführen
// window.addEventListener('load', adjustBodyPaddingToNavigation);

(window as any).toggleNavElements = toggleNavElements;
(window as any).toggleInnerNavElement = toggleInnerNavElement;